<template>
  <router-view />
</template>

<script>
export default {
  name: "accounting",
  components: {},
};
</script>
